export default __webpack_public_path__ + "static/media/the_globe_and_mail_logo.png";